// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackForm-cls1_K4d","cls2":"FeedbackForm-cls2_-2r FeedbackForm-cls1_K4d"};